import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../commonComponents/translate';
import { useScrollAnchor } from '../../services/customHooks';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import ServerSideCarousel from '../../commonComponents/carousel/ServerSideCarousel';
import JourneysCarouselItem from './JourneysCarouselItem';
import JourneysAcademyList from './JourneysAcademyList';
import JourneyFilters from './JourneyFilters';
import CourseTagProp from '../../commonComponents/propTypes/CourseTagProp';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import PriceRangeProp from '../academy/propTypes/PriceRangeProp';
import Notifications from '../../services/notifications';

const fetchMyJourneysTotal = async () => {
  const url = '/table/journey/list?isPublic=true&status=in_progress';
  const params = {
    pagination: {
      page: 1,
      perpage: 1,
    },
  };
  const { data: response } = await axios.get(url, {
    params,
    headers: {
      'Accept-Version': '1.0.0',
      'X-Gamification-API': 'Games',
    },
  });
  return response?.data?.length > 0;
};

function JourneyAcademy(props) {
  const { t, languages, currencies, tags, applyFilters, priceRange } = props;

  const { contentElement, scrollToContent } = useScrollAnchor();
  const [myJourneys, setMyJourneys] = useState(0);
  const [query, setQuery] = useState({
    language: '',
    maxPrice: priceRange.max,
    tags: '',
    search: '',
  });
  const handleQueryChange = value => {
    setQuery(q => ({ ...q, ...value }));
    scrollToContent();
  };

  const handleChange = field => value => {
    setQuery(q => ({ ...q, [field]: value }));
    scrollToContent();
  };

  const { loggedUser } = useContext(LoggedUserContext);

  /** Set State = localStorage */
  useEffect(() => {
    // if redirect is with ?applyFilters=true, apply filters
    if (applyFilters) {
      if (
        localStorage.getItem('journeysFilter') &&
        localStorage.getItem('journeysFilter').length > 0
      ) {
        setQuery(JSON.parse(localStorage.getItem('journeysFilter')));
      }
    } else {
      localStorage.removeItem('journeysFilter');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('journeysFilter', JSON.stringify(query));
  }, [query]);

  useEffect(() => {
    fetchMyJourneysTotal()
      .then(total => {
        setMyJourneys(total);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err);
      });
  }, [setMyJourneys]);

  return (
    <>
      {loggedUser && myJourneys > 0 && (
        <>
          <h4 className="sessions-subtitle-title journey-errollItem">
            {t('academy.my.journeys.title')}
          </h4>
          <div className="m-portlet__body related-container">
            <ServerSideCarousel
              id="my-journeys-carousel"
              fetchUrl="/table/journey/list?isPublic=true&status=in_progress"
              defaultFetchError="error_fetchSessions"
            >
              {items =>
                items.map(journey => (
                  <JourneysCarouselItem
                    key={journey._id}
                    className=""
                    journey={journey}
                  />
                ))
              }
            </ServerSideCarousel>
            <h4 className="sessions-subtitle-title available-sessions">
              {t('academy.available.journeys')}
            </h4>
          </div>
        </>
      )}
      <div className="row">
        <div className="col-lg-3 filters-shop-desktop">
          <JourneyFilters
            currencies={currencies}
            languages={languages}
            selected={query}
            tags={tags}
            onChange={handleQueryChange}
            onPriceChange={handleChange}
            priceRange={priceRange}
          />
        </div>
        <div className="col-lg-9" ref={contentElement}>
          <JourneysAcademyList
            query={query}
            languages={languages}
            onChange={handleChange}
            currencies={currencies}
            tags={tags}
            onQueryChange={handleQueryChange}
            priceRange={priceRange}
          />
        </div>
      </div>
    </>
  );
}

JourneyAcademy.propTypes = {
  t: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

JourneyAcademy.defaultProps = {
  tags: [],
  applyFilters: false,
};

export default translate(JourneyAcademy);
